import { microservices } from './microservices.az';

export interface IEnvironment extends ICommonConfigurations,
    IEnvironmentSpecificConfigurations,
    IEnvironmentSpecificServiceList {
}

interface ILanguage {
    flag: string;
    id: string;
    title: string;
    value: string;
}


export interface ICommonConfigurations {
    NotificationHubName: string;
    PersonFields: string[];
    SiteLogo: string;
    topBgImageUrl: string;
    defaultLangKey: string;
    language: ILanguage[];
    CdnBaseUrl: string;
    currentDateFormat: string;
    DefaultPackagePath: string;
    isFloatingChatPanelEnable: boolean;
    CdnTenantBaseUrl: string;
    EmailValidatorRegex: string;
    toBgImages: string[];
    currency: string;
    Client_ID: string;
}


export interface IEnvironmentSpecificConfigurations {
    SiteId: string;
    production: boolean;
    DomainName: string;
    SubDomainName: string;
    initialNavigation: any;
    landingUri: string;
    BuildPipelineId: string;
    IsAzStorage: boolean;
    SessionKey: string;
    beeUid: string;
    IsStaging: boolean;
    isSSo: boolean;
    BuildVersion: string;
    action: string;
    isDevLocal?: boolean;
    MaintenanceManagerURL: string;
    JarowaWorkorderUrl?: string;
    WagePredictionServiceUserName: string;
    WagePredictionServicePassword: string;
    WagePredictionService: string;
    caseCenterUri: string;
    SlackWebHookUrl: string;
    SlackAdminWebHookUrl: string;
    ClaimCenterUri: string;
    IpexFileService: string;
    IpexDataBeastService: string;
    ClaimCenterLinkBaseUri: string;
    UILMUrl: string;
    ProjectKey: string;
    AutoClearingUserId: string;
}


export interface IEnvironmentSpecificServiceList {
    Token: string;
    Security: string;
    Apps: string;
    GQLQueryUri: string;
    PCXBusiness: string;
    Identity: string;
    TemplateEngineService: string;
    NotificationService: string;
    StaticResourceCDN: string;
    Sites: string;
    SecurityIdentity: string;
    Captcha: string;
    GQLMutationUri: string;
    Storage: string;
    EmailSyncService: string;
    EmailService: string;
    DataCore: string;
    AggregateService: string;
    PdfGeneratorV2?: string;
}

export class EnvironmentSpecificServiceList implements IEnvironmentSpecificServiceList {
    AggregateService: string;
    Apps: string;
    Captcha: string;
    DataCore: string;
    EmailService: string;
    EmailSyncService: string;
    GQLMutationUri: string;
    GQLQueryUri: string;
    Identity: string;
    NotificationService: string;
    PCXBusiness: string;
    PdfGeneratorV2: string;
    Security: string;
    SecurityIdentity: string;
    Sites: string;
    StaticResourceCDN = `https://stg-ecap.s3.eu-central-1.amazonaws.com/`;
    Storage: string;
    TemplateEngineService: string;
    Token: string;
    constructor(env: 'dev' | 'stg' | 'prod', isLocal = false) {
        let baseUrl = microservices[(isLocal ? 'local' : env) + 'BaseUrl'];
        const getServiceUrl = (service: string): string => {
            if (!microservices[service]) {
                throw new Error('service not found');
            }
            let serviceUrl = `${baseUrl}/${microservices[service].urlPrefix}/${microservices[service][env]}`;
            if(env === "dev" && microservices[service].urlPrefix === 'notification'){
                serviceUrl = `https://msblocks.seliselocal.com/api/${microservices[service].urlPrefix}/${microservices[service][env]}`;
            }
            return serviceUrl[serviceUrl.length - 1] === '/' ? serviceUrl.slice(0, serviceUrl.length - 1) : serviceUrl;
        };

        this.AggregateService = `${getServiceUrl('aggregator')}/Service-Aggregator/ServiceAggrigation/`;
        this.Apps = `${getServiceUrl('appCatalogue')}/AppCatalogue/AppManagerQuery/GetApps`;
        this.Captcha = `${getServiceUrl('captcha')}/Captcha/CaptchaCommand/`;
        this.DataCore = `${getServiceUrl('pds')}/AppSuiteDataCore/`;
        this.EmailService = `${getServiceUrl('mailService')}/MailService`;
        this.EmailSyncService = `${getServiceUrl('emailSyncService')}/EmailSyncService/`;
        this.GQLMutationUri = `${getServiceUrl('gqlCommand')}/graphql`;
        this.GQLQueryUri = `${getServiceUrl('gqlQuery')}/graphql`;
        this.Identity = `${getServiceUrl('tenant')}/TenantManager/TenantManagerQuery/GetIdentity`;
        this.NotificationService = `${getServiceUrl('notification')}/`;
        this.PCXBusiness = `${getServiceUrl('pcxBusinessService')}/PCXWebService/`;
        this.PdfGeneratorV2 = `${getServiceUrl('pdfGenerator2')}/PdfGeneratorHost/`;
        this.Security = `${getServiceUrl('uam')}/UserAccessManagement/`;
        this.SecurityIdentity = `${getServiceUrl('identity')}/identity/`;
        this.Sites = `${getServiceUrl('tenant')}/TenantManager/SiteManagerQuery/GetSites`;
        this.Storage = `${getServiceUrl('storageService')}/StorageService/`;
        this.TemplateEngineService = `${getServiceUrl('templateEngine')}/TemplateEngineService/`;
        this.Token = `${getServiceUrl('identity')}/identity/token`;
    }
}
